export const FREE_SPINS_BG = '/images/widgets/frb_widget_bg.svg';
export const FREE_SPINS_BG_SUBTRACT = '/images/widgets/frb_widget_bg_subtract.svg';

export const BINGO_DAUB = '/images/widgets/bingo_widget_daub.webp';
export const BINGO_DAUB_BG = '/images/widgets/bingo_widget_daub_bg.webp';
export const BINGO_NEW_PLAYER_BG = '/images/widgets/bingo_widget_new_player_bg.webp';
export const BINGO_DIAMOND_BG = '/images/widgets/bingo_widget_diamond_bg.webp';
export const BINGO_TEXT = '/images/widgets/bingo_widget_text.webp';
export const BINGO_LOGO_BG_CASUAL = '/images/widgets/bingo_widget_logo_bg_casual.webp';
export const BINGO_LOGO_BG_SWEEPS = '/images/widgets/bingo_widget_logo_bg_sweeps.webp';
export const BINGO_BOARD_LEFT_CASUAL = '/images/widgets/bingo_widget_board_left_casual.webp';
export const BINGO_BOARD_LEFT_SWEEPS = '/images/widgets/bingo_widget_board_left_sweeps.webp';
export const BINGO_BOARD_RIGHT_CASUAL = '/images/widgets/bingo_widget_board_right_casual.webp';
export const BINGO_BOARD_RIGHT_SWEEPS = '/images/widgets/bingo_widget_board_right_sweeps.webp';

export const CHALLENGE_WIDGET = '/images/widgets/challenge_widget.webp';
export const CHALLENGE_WIDGET_TEXT = '/images/widgets/challenge_widget_text.webp';
export const CHALLENGE_PROGRESS_BG = '/images/widgets/challenge_widget_progress_bg.webp';
